import { useId } from 'react';

export default function ApplicationCheckbox({
  id,
  label,
  helperText,
  error,
  density = 'default',
  className = '',
  ...inputProps
}) {
  const generatedId = useId();
  const controlId = id || `av-app-checkbox-${generatedId}`;
  const helperId = helperText ? `${controlId}-helper` : undefined;
  const errorId = error ? `${controlId}-error` : undefined;
  const describedBy = [errorId, helperId].filter(Boolean).join(' ') || undefined;

  if (!['default', 'compact'].includes(density)) {
    throw new Error(`Unsupported ApplicationCheckbox density: ${density}`);
  }

  const classes = [
    'av-app-checkbox',
    density === 'compact' ? 'av-app-checkbox--compact' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className="av-app-checkbox__control-row">
        <input
          {...inputProps}
          aria-describedby={describedBy}
          aria-invalid={Boolean(error)}
          className="av-app-checkbox__control"
          id={controlId}
          type="checkbox"
        />
        <label className="av-app-checkbox__label" htmlFor={controlId}>
          {label}
        </label>
      </div>

      {error && (
        <p className="av-app-checkbox__error" id={errorId}>
          {error}
        </p>
      )}

      {helperText && (
        <p className="av-app-checkbox__helper" id={helperId}>
          {helperText}
        </p>
      )}
    </div>
  );
}
